/**
 * アプリケーションを問わずで基本的に共通で用いる定数値
 */
export var EnvironmentName;
(function (EnvironmentName) {
    // 環境名(3文字で揃える)
    EnvironmentName["DEV"] = "dev";
    EnvironmentName["TST"] = "tst";
    EnvironmentName["STG"] = "stg";
    EnvironmentName["PRD"] = "prd";
})(EnvironmentName || (EnvironmentName = {}));
export var StatusCode;
(function (StatusCode) {
    // 成功ステータスコード
    StatusCode[StatusCode["Ok"] = 200] = "Ok";
    StatusCode[StatusCode["Created"] = 201] = "Created";
    StatusCode[StatusCode["Accepted"] = 202] = "Accepted";
    StatusCode[StatusCode["NoContent"] = 204] = "NoContent";
    // リダイレクト
    StatusCode[StatusCode["MovedPermanently"] = 301] = "MovedPermanently";
    StatusCode[StatusCode["Found"] = 302] = "Found";
    // クライアントエラーステータスコード
    StatusCode[StatusCode["BadRequest"] = 400] = "BadRequest";
    StatusCode[StatusCode["Unauthorized"] = 401] = "Unauthorized";
    StatusCode[StatusCode["Forbidden"] = 403] = "Forbidden";
    StatusCode[StatusCode["NotFound"] = 404] = "NotFound";
    // サーバーエラーステータスコード
    StatusCode[StatusCode["InternalServerError"] = 500] = "InternalServerError";
    StatusCode[StatusCode["NotImplemented"] = 501] = "NotImplemented";
    StatusCode[StatusCode["BadGateway"] = 502] = "BadGateway";
    StatusCode[StatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    StatusCode[StatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
})(StatusCode || (StatusCode = {}));
// ページ名
export const PAGE_INDEX = "index.html";
export const PAGE_LOGIN = "login.html";
// SEJ・7&i
export const COMPANY_ID_SEJ = "SEJ";
export const COMPANY_ID_7andi = "7&i";
// 数字（int型）
export const ZERO = 0;
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const FIVE = 5;
export const SIX = 6;
export const SEVEN = 7;
export const EIGHT = 8;
export const NINE = 9;
// 数字（文字列型）
export const ZERO_STRING = "0";
export const ONE_STRING = "1";
export const TWO_STRING = "2";
export const THREE_STRING = "3";
export const FOUR_STRING = "4";
export const FIVE_STRING = "5";
export const SIX_STRING = "6";
export const SEVEN_STRING = "7";
export const EIGHT_STRING = "8";
export const NINE_STRING = "9";
// 拡張子
export const EXTENSION_CSV = ".csv";
// 1度の距離(緯度経度混在の場合のおおよその値)
export const ONE_DEGREE_KILO_METER = 111;
